define(function (require) {

    var Multiselect = require("ui/multiselect/Multiselect");
    var lpUtils = require('utils/lpUtils');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');
    var ButtonDropdownViewController = require('web-agent-components/ButtonDropdownViewController');

    var SEARCH_OPTIONS = {
        name: "name",
        id: "id",
    };

    var FilterItemSurveyNameId = BaseFilterItem.extend({
        ControllerName: 'FilterItemSurveyNameIdViewController',
        LPViewMap: {
            searchDropdownSelection: ".lpview_search_survey_name",
            fullTableContainer: "list_table_container",
            listContainer: "list-container",
            searchNameId: ".lpview_search_name_id"
        },
        LPTemplatesFiles: {
            filterSearchDropdownSelection: "LP_filter_search_survey_name_id_selection_view.html"
        },
        LPClassesMap: {
            hidden: "hidden"
        },
        LPElementsMap: {
            textInput: "input"
        },
        LPSearchOptions: SEARCH_OPTIONS,


        initialize: function (constructorData) {
            this.filterDataModelPath = constructorData.filterDataModelPath;
            this.publishProperty = constructorData.publishProperty || "id";
            this.textProperty = constructorData.textProperty || "name";
            this.titleText = "filter_title_" + constructorData.filterTextSuffix;
            this.floating = constructorData.floating || false;
            this.selectedItems = [];
            this.searchMethod = "name";
            this.idPlaceHolderText = constructorData.idPlaceHolderText;
            this.searchOptions = [];
            this.searchOptions.push({ type: "name", text: this.translate("history_search_filter_survey_name") });
            this.searchOptions.push({ type: "id", text: this.translate("history_search_filter_survey_id") });

            this.viewInit();
        },
        events: function () {
        },

        render: function () {
            this.multiselect.render();
            this._updateViewByCurrentSearchMethod();
        }
    });

    FilterItemSurveyNameId.prototype.onSearchMethodChanged = function (data) {
        if (data && data.rowData && data.rowData.type) {
            this.updateSearchMethod(data.rowData.type);
        }
    };

    FilterItemSurveyNameId.prototype.updateSearchMethod = function (searchMethod) {
        if (!searchMethod || searchMethod === this.searchMethod) {
            return;
        }

        // update search method
        this.searchMethod = searchMethod;

        this._updateViewByCurrentSearchMethod();
    };

    FilterItemSurveyNameId.prototype.getSearchIndex = function () {
        var searchMethod = this.searchMethod;
        return _.findIndex(this.searchOptions, function(o) { return o.type === searchMethod; });
    };

    FilterItemSurveyNameId.prototype._updateViewByCurrentSearchMethod = function () {
        this.surveySearchTypeVC.setSelectedIndex(this.getSearchIndex(this.searchMethod));
        if(this.searchMethod === this.LPSearchOptions.name) {
            this.removeClass(this.LPViewMap.searchDropdownSelection, this.LPClassesMap.hidden);
            this.addClass(this.LPElementsMap.textInput, this.LPClassesMap.hidden);
        } else if(this.searchMethod === this.LPSearchOptions.id) {
            this.addClass(this.LPViewMap.searchDropdownSelection, this.LPClassesMap.hidden);
            this.removeClass(this.LPElementsMap.textInput, this.LPClassesMap.hidden);
        }

    };

    FilterItemSurveyNameId.prototype.viewInit = function () {
        var tableTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.filterSearchDropdownSelection);
        this.createView(
            {
                template: tableTemplate,
                textInjection: {
                    id_placeholder: this.idPlaceHolderText
                }
            });

        this.surveySearchTypeVC = new ButtonDropdownViewController({
            items: this.searchOptions,
            selectedIndex: 0,
            context: this,
            itemClicked: this.onSearchMethodChanged,
            textProperty: "text"
        });
        this.addViewController({
            viewController: this.surveySearchTypeVC,
            target: this.LPViewMap.searchNameId
        });

        var dropdownContainer = this.getFirstElement(this.LPViewMap.searchDropdownSelection);

        var multiselectConfigData = {
            container: $(dropdownContainer),
            trim: true,
            items: [],
            floating: this.floating || false,
            selectedItems: [],
            list: {
                maxShownItems: 5,
                noItems: {
                    visible: true,
                    value: this.noResultsText
                }
            },
            tagsContainer: {
                placeholder: this.translate(this.titleText),
                maxShownLines: 5,
                inlineErrorText: "",
                tagMaxWidth: "150px"
            }
        };

        this.multiselect = new Multiselect(multiselectConfigData);
        this.multiselect.on(Multiselect.TRIGGERING.SELECT,this._onActionSelected,this);
        this.multiselect.on(Multiselect.TRIGGERING.UNSELECT,this._onActionUnselected,this);
    };

    FilterItemSurveyNameId.prototype._onActionSelected = function(actionId) {
        this.selectedItems.push(actionId.id);
    };

    FilterItemSurveyNameId.prototype._onActionUnselected = function(actionId) {
        var position = this.selectedItems.indexOf(actionId.id);
        if (position !== -1) {
            this.selectedItems.splice(position, 1);
        }
    };

    FilterItemSurveyNameId.prototype.getValue = function () {
        var surveyIds;
        if(this.searchMethod === this.LPSearchOptions.name) {
            surveyIds = (this.selectedItems.length > 0) ? this.selectedItems.toString() : undefined;
        } else if(this.searchMethod === this.LPSearchOptions.id) {
            var inputElement = this.getFirstElement(this.LPElementsMap.textInput, this.view);
            surveyIds = (inputElement && inputElement.value) ? inputElement.value : undefined;   //empty string should return as undefined
        }
        var result = {
            searchMethod: this.searchMethod,
            surveyIds: surveyIds
        };
        return result;
    };

    FilterItemSurveyNameId.prototype.getLatestItems = function () {
        this.controllerModelParam = App.agentController.getModelParam(this.filterDataModelPath);

        var list = this.controllerModelParam ? lpUtils.cloneObject(this.controllerModelParam) : [];

        var self= this;
        list = _.map(list, function(item) {
            var itemToReturn = {
                id: item[self.publishProperty],
                value: item[self.textProperty]
            };
            return itemToReturn;
        });

        return list;
    };

// set the tags and dropdown according to the data in the filter
    FilterItemSurveyNameId.prototype.updateFilterUI = function (filterUIData) {

        this.searchMethod = (_.isUndefined(filterUIData) || _.isUndefined(filterUIData.searchMethod)) ? SEARCH_OPTIONS.name : filterUIData.searchMethod;

        var itemIdsArray;
        var list = [];
        //clear all tags and selected items
        this.multiselect.clearInputValue();
        this.multiselect.unselectAll();
        this.selectedItems = [];

        //set the items list from model
        list = this.getLatestItems();
        this.multiselect.setItems(list);

        //set the relevant tags and selected items
        var self = this;
        var surveyIds;
        if (!_.isUndefined(filterUIData) && filterUIData.surveyIds) {
            itemIdsArray = filterUIData.surveyIds.split(',');
            _.forEach(itemIdsArray, function (itemId) {
                if (_.find(list, function (el) {
                        return el.id == itemId;
                    })) {
                    itemId = parseInt(itemId, 10) ? parseInt(itemId, 10) : itemId; //if the id is number convert it to int otherwise take it as string
                    self._onActionSelected({id: itemId});
                    self.multiselect.select(itemId);
                }
            });
            surveyIds = filterUIData.surveyIds;
        } else {
            surveyIds = "";
        }
        this.getFirstElement(this.LPElementsMap.textInput, this.view).value = surveyIds;
        this._updateViewByCurrentSearchMethod();
    };

    return FilterItemSurveyNameId;
});
